var img = document.querySelector(".anime-large");

img.addEventListener("mouseenter", function () {
    img.classList.add("hovered");
});

img.addEventListener("mouseleave", function () {
    img.classList.remove("hovered");
});
